import React from 'react';
//import styled from 'styled-components';
import { Level } from 'rbx';
import { Radio } from '../../../components/elements';

const PhotoUpload = ({ statusFilter, setStatusFilter }) => (
  <Level>
    <Level.Item align="right">
      <Level.Item>
        <Radio
          label="Add a Review"
          value={statusFilter === 'ADD A REVIEW'}
          onChange={value => {
            if (value) {
              setStatusFilter('ADD A REVIEW');
            }
          }}
        />
      </Level.Item>
      <Level.Item>
        <Radio
          label="Upload Place Photo"
          value={statusFilter === 'UPLOAD PLACE PHOTO'}
          onChange={value => {
            if (value) {
              setStatusFilter('UPLOAD PLACE PHOTO');
            }
          }}
        />
      </Level.Item>
    </Level.Item>
  </Level>
);

export default PhotoUpload;
